import { render, staticRenderFns } from "./Wip.vue?vue&type=template&id=6496296f&scoped=true&class=myBG&"
import script from "./Wip.vue?vue&type=script&lang=js&"
export * from "./Wip.vue?vue&type=script&lang=js&"
import style0 from "./Wip.vue?vue&type=style&index=0&id=6496296f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6496296f",
  null
  
)

export default component.exports